import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { showTherapist } from "@/Services/TherapyApi/Users";

import useUserStore from "@/Modules/User/Store";
import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";

async function showTherapistAH() {
  const userStore = useUserStore();
  const appStore = useAppStore();

  userStore.isLoading = true;

  try {
    await showTherapist();
  } catch (e) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
    danger(e);
  } finally {
    userStore.isLoading = false;
  }
}

export default showTherapistAH;
